export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/CarsNoAcc.436bcdc2.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};